import React, {Component} from 'react'
import { connect } from 'react-redux'
import ClassDetail from '../ClassDetail'

const mapStateToProps = (state) => ({
  user: state.user
})

class ClassOneDetail extends Component{
  render(){
    return(
      <ClassDetail params={this.props.params} {...this.props} />
    )
  }
}

export default connect(mapStateToProps)(ClassOneDetail)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassOneDetail/index.js